<template>
  <v-dialog
    ref="dialog"
    :value="show"
    persistent
    fullscreen
    :overlay="true"
    scrollable
    class="ma-0 pa-0"
  >
    <v-card
      v-if="showDelayHide"
      class="ft-editor-dialog-content"
    >
      <page-bar
        :title="title"
        :on-back="onBack"
        :on-close="onClose"
        :back-tip="backTip"
        :context-menu="contextMenu"
        :save-button="saveButton"
        :lock-timer="lockTimer"
        :loading="loading"
        :secondary="secondary"
        :fixed="true"
        :hide-page-scrollbar="show"
        :buttons="buttons"
      >
        <template slot="bar-right">
          <slot name="bar-right" />
        </template>
        <template slot="default">
          <slot name="before-progress" />
        </template>
        <template slot="after-progress">
          <slot name="after-progress" />
        </template>
      </page-bar>
      <v-card-text
        id="ft-editor-scroll-window"
        v-scroll:#ft-editor-scroll-window="editorDialogScroll"
        class="ma-0 pa-0 pb-3"
      >
        <api-errors :errors="errors" />
        <item-editor-form
          ref="editForm"
          :audit-panel-id="auditPanelId"
          :edit-panel-id="editPanelId"
          :audit-name-not-found="auditNameNotFound"
          :audit-name="auditName"
          :value="selectedTab"
          :audit="audit"
          :errors="errors"
        >
          <slot />
        </item-editor-form>
      </v-card-text>
      <!-- empty v-card-actions helps data float to top -->
      <v-card-actions class="ma-0 pa-0" />
    </v-card>
  </v-dialog>
</template>

<script>
import ItemEditorForm from './ItemEditorForm'
import {updateMenuDimensionsOfChildren} from '../util/helpers'

export default {
  name: 'ItemEditorDialog',
  components: {ItemEditorForm},
  props: {
    // Page Bar
    title: String,
    id: [String, Number, Object],
    cloneId: [String, Number, Object],
    onBack: [Function, Boolean],
    onClose: Function,
    backTip: [String, Boolean],
    contextMenu: Array,
    saveButton: [Object, Boolean],
    lockTimer: [Object, Boolean],
    loading: Boolean,
    secondary: Boolean,
    // Item editor Form
    auditPanelId: String,
    editPanelId: String,
    auditNameNotFound: Function,
    auditName: Function,
    value: String,
    audit: Object,
    buttons: Array,
    show: Boolean,
    errors: Array // Deprecated
  },

  data: function () {
    return {
      selectedTab: null,
      showDelayHide: false,
      dialogScrollTimeout: null
    }
  },
  watch: {
    value (val) {
      this.selectedTab = val
    },
    selectedTab (val) {
      this.$emit('input', val)
    },
    show (val) {
      if (val) {
        // this.$refs.dialog.animateClick = () => {} // Hack to work-around persistent dialog pulse animation
        this.showDelayHide = this.show
      } else {
        setTimeout(() => {
          this.showDelayHide = this.show
        }, 500)
      }
    }
  },
  mounted () {
    this.selectedTab = this.value
    console.warn('Editor Dialog Open - 1', this.$refs.dialog)
  },
  methods: {
    validate () {
      if (this.$refs.editForm) {
        return this.$refs.editForm.validate()
      }
    },
    editorDialogScroll (e) {
      // Unfortunately, "attach" on v-select. v-autocomplete, v-menu, etc., doesn't work all the time, so they only scroll with the main body, not the scrollable content in a v-dialog.
      // We'll need to iterate through all children to force any of these open components to reposition after a v-dialog scrolls.
      clearTimeout(this.dialogScrollTimeout)
      this.dialogScrollTimeout = setTimeout(() => updateMenuDimensionsOfChildren(this.$refs.editForm), 100)
    }
  }

}
</script>
